<template>
  <div class="children-detail-container">
    <h3>Профиль ребенка</h3>
    <div v-if="childProfileInfo">
      <div class="info-section">
        <p><strong>ИИН ребенка:</strong> {{ childProfileInfo.childIin }}</p>
        <p><strong>ФИО ребенка:</strong> {{ childProfileInfo.childFio }}</p>
        <p><strong>ИИН родителя:</strong> {{ childProfileInfo.parentIin }}</p>
        <p><strong>ФИо родителя:</strong> {{ childProfileInfo.parentFio }}</p>
        <p><strong>Временный адрес ребенка:</strong> {{ childProfileInfo.childTemporaryAddress }}</p>
        <p><strong>Постоянный адрес ребенка:</strong> {{ childProfileInfo.childFixedAddress }}</p>
        <p><strong>Временный адрес родителя:</strong> {{ childProfileInfo.parentTemporaryAddress }}</p>
        <p><strong>Постоянный адрес родителя:</strong> {{ childProfileInfo.parentFixedAddress }}</p>
      </div>
    </div>
    <div v-else>Загрузка...</div>

    <!-- Bootstrap навигация -->
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <router-link
            :to="`/children/${childId}/kindergartens`"
            class="nav-link"
            active-class="active"
        >
          Данные об образовании в ДО
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
            :to="`/children/${childId}/payments`"
            class="nav-link"
        >
          Оплаты
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
            :to="`/children/${childId}/timesheets`"
            class="nav-link"
        >
          Табели
        </router-link>
      </li>
    </ul>

    <div class="child-info-part-content">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {ChildProfileInfoResponse} from "@/types/childrenResponse";
import {getChildProfileById} from "@/services/childrenService";
import {useRoute} from "vue-router";
import router from "@/router";

export default defineComponent({
  name: 'ChildrenDetailView',
  setup() {
    const childProfileInfo = ref<ChildProfileInfoResponse | null>(null);
    const childId = ref<string>("");

    const fetchChildrenDocumentInfo = async () => {
      try {
        childProfileInfo.value = await getChildProfileById(childId.value);
      } catch (error) {
        console.error("Ошибка при получении информации");
      }
    }

    onMounted(async () => {
      const route = useRoute();
      childId.value = route.params.id as string;
      await fetchChildrenDocumentInfo();
      if (router.currentRoute.value.path === `/children/${childId.value}`) {
        router.push(`/children/${childId.value}/kindergartens`);
      }
    });

    return {
      childId,
      childProfileInfo,
    };
  }
});
</script>

<style scoped>
.children-detail-container {
  padding: 20px;
}
.info-section {
  margin-bottom: 20px;
}
</style>